export default __webpack_public_path__ + "static/media/schedule-icon.fbc26d3a.svg";